/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/styles/makeStyles';
import ChevronRight from '@material-ui/icons/ChevronRight';
import classNames from 'classnames';
import { Avatar, Box } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    margin: '.5rem .7rem 0 .7rem',
    padding: '.7rem',
  },
  divider: {
    margin: '.5rem 0 0',
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  header: {
    width: '100%',
    justifyContent: 'space-between',
    '& svg': {
      color: theme.palette.primary.main,
    },
    ' & p': {
      marginLeft: theme.spacing(1),
      fontWeight: 500,
      fontSize: '1.5rem',
    },
  },
  avatarPrimary: {
    color: theme.palette.avatar.primary.text,
    backgroundColor: theme.palette.avatar.primary.background,
  },
  avatarSecondary: {
    color: theme.palette.avatar.secondary.text,
    backgroundColor: theme.palette.avatar.secondary.background,
  },
}));

function stringAvatar(name) {
  return {
    children: `${name.charAt(0)}`,
  };
}

export function SwitchAccountCardHeader({ id, className, name, initials }) {
  const classes = useStyles();

  return (
    <Box id={`${id}-header`} className={classes.root} aria-label={id}>
      <Box>
        <Avatar className={className} {...stringAvatar(initials)} />
      </Box>
      <Box className={classNames(classes.textContainer, classes.header)}>
        <Typography>{name}</Typography>
        <ChevronRight fontSize="large" />
      </Box>
    </Box>
  );
}
